import {css} from '@isceco/widget-library2/external/lit'

export const mindestlohnrechnerStyles = css`
  .page-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    padding: 1rem;
    box-sizing: border-box;
  }

  .intro-text {
    margin-bottom: 2rem;
    line-height: 1.6;
  }

  .field-wrapper {
    margin-bottom: 1.5rem;
  }

  .field-label {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 0.5rem;
  }

  .field-label-text {
    font-weight: bold;
  }

  .info-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: var(--isceco-color-blue-500);
    color: white;
    font-size: 0.75rem;
    cursor: help;
  }

  .field-wrapper isceco-dropdown,
  .field-wrapper isceco-date-input {
    max-width: 400px;
    width: 100%;
  }

  .popup-content {
    padding: 1rem;
    max-width: 320px;
    line-height: 1.5;
  }

  .beruf-hint {
    margin: 2rem 0 1rem;
    line-height: 1.6;
  }

  .result-section h2 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .result-section--separated {
    margin-top: 2rem;
    padding-top: 2rem;
    border-top: 1px solid #ddd;
  }

  .result-cards {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    max-height: 55vh;
    overflow-y: auto;
    padding-right: 0.25rem;
  }

  .input-summary-wrapper {
    margin: 1rem 0 1.5rem;
  }

  .result-card-content,
  .input-summary-card {
    padding: 1rem 1.5rem;
  }

  .no-results {
    padding: 1rem;
    line-height: 1.6;
    font-style: italic;
    color: #666;
  }

  .relevant-links {
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid #ddd;
  }

  .relevant-links-title {
    font-weight: bold;
    margin-bottom: 1rem;
  }

  .relevant-links-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 1rem;
  }

  .card-description {
    color: var(--isceco-color-black-500, #333);
    margin: 0.4rem 0 0;
    line-height: 1.4;
  }

  .selection-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .selection-row input[type="radio"] {
    width: 16px;
    height: 16px;
  }

  .selection-title {
    font-weight: bold;
  }

  .accordion-group {
    margin-top: 0.75rem;
  }

  .accordion-item {
    background: #f3f4f6;
    border-radius: 4px;
    padding: 0.35rem 0.75rem 0.25rem;
    margin-bottom: 0.5rem;
  }

  .accordion-item.no-background {
    background: transparent;
    border-radius: 0;
    padding: 0;
  }

  .accordion-toggle {
    width: 100%;
    text-align: left;
    border: none;
    background: transparent;
    padding: 0.25rem 0;
    cursor: pointer;
    color: #1f1f1f;
    font-weight: 600;
  }

  .accordion-content {
    padding: 0.25rem 0 0.75rem 0;
    line-height: 1.5;
    white-space: normal;
    font-size: 0.9rem;
  }

  .accordion-content p,
  .accordion-content div {
    margin: 0 0 0.5rem 0;
  }

  .accordion-content ol,
  .accordion-content ul {
    margin: 0.25rem 0 0.75rem 1.25rem;
  }

  .auskuenfte-content {
    line-height: 1.6;
  }

  .auskuenfte-content p,
  .auskuenfte-content div {
    margin: 0 0 0.2rem 0;
  }

  .auskuenfte-content .no-match-contacts {
    gap: 0.35rem;
  }

  .auskuenfte-content .no-match-contact-item strong {
    color: #1f1f1f;
    font-weight: 700;
  }

  .auskuenfte-content a {
    color: var(--isceco-color-blue-500);
    text-decoration: underline;
  }

  .no-match-contacts {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .no-match-contact-item {
    line-height: 1.6;
  }

  .no-match-contact-item strong {
    color: var(--isceco-color-blue-500);
  }

  .action-buttons {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-start;
    gap: 0.75rem;
    flex-wrap: wrap;
  }

  .action-buttons-end {
    justify-content: flex-end;
  }

  .detail-footer-buttons {
    margin: 1rem 0 1.5rem;
  }

  .selected-contract-value {
    margin: 1rem 0 0.5rem;
    line-height: 1.5;
  }

  .selected-contract-value a {
    font-size: inherit;
    color: #4c9aff;
  }

  .detail-content-section {
    margin-top: 1rem;
  }

  .mindestloehne-card-content {
    padding: 1rem 1.5rem;
  }

  .employee-data-header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.75rem;
    min-height: 1.75rem;
  }

  .employee-data-loading {
    color: #666;
    font-size: 0.9rem;
    white-space: nowrap;
  }

  .employee-data-loading[hidden] {
    visibility: hidden;
    display: inline;
  }

  .gav-kurz-card-content {
    padding: 1rem 1.5rem;
  }

  .gav-kurz-card-content > h3 {
    margin: 0 0 0.75rem;
  }

  .gav-kurz-group-title {
    margin: 1rem 0 0.5rem;
    font-size: 1rem;
    font-weight: 600;
  }

  .gav-kurz-card-content .accordion-toggle {
    font-size: 0.95rem;
  }

  .gav-kurz-card-content .accordion-content {
    font-size: 0.88rem;
    line-height: 1.55;
  }

  .gav-kurz-card-content .accordion-content h6 {
    font-size: 0.92rem;
    font-weight: 600;
    margin: 0.45rem 0 0.25rem;
    line-height: 1.45;
  }

  .gav-kurz-card-content .accordion-content h1,
  .gav-kurz-card-content .accordion-content h2,
  .gav-kurz-card-content .accordion-content h3,
  .gav-kurz-card-content .accordion-content h4,
  .gav-kurz-card-content .accordion-content h5 {
    /* Keep default browser heading sizing for other heading levels. */
    font-size: inherit;
  }

  .gav-kurz-card-content .accordion-content table {
    width: 100%;
    border-collapse: collapse;
    table-layout: auto;
    margin: 0.5rem 0;
  }

  .gav-kurz-card-content .accordion-content th,
  .gav-kurz-card-content .accordion-content td {
    text-align: left !important;
    vertical-align: top;
    border: 1px solid #d1d5db;
    padding: 0.45rem 0.55rem;
    font-size: inherit;
    line-height: inherit;
  }

  .gav-kurz-card-content .accordion-content thead th {
    background: #f9fafb;
    font-weight: 600;
  }

  .no-match-card-content {
    padding: 1rem 1.5rem;
  }

  .no-match-salary-card-content {
    padding: 1rem 1.5rem;
  }

  .no-match-salary-card {
    margin-top: 0.75rem;
  }

  .input-summary-card > :first-child,
  .mindestloehne-card-content > :first-child,
  .gav-kurz-card-content > :first-child,
  .no-match-card-content > :first-child {
    margin-top: 0;
  }

  .input-summary-card > :last-child,
  .mindestloehne-card-content > :last-child,
  .gav-kurz-card-content > :last-child,
  .no-match-card-content > :last-child {
    margin-bottom: 0;
  }

  .no-match-salary-card-content > :first-child {
    margin-top: 0;
  }

  .no-match-salary-card-content > :last-child {
    margin-bottom: 0;
  }

  .contacts-block {
    margin-top: 0.5rem;
  }

  .contacts-subsection {
    margin-bottom: 1rem;
  }

  .contacts-subsection-title {
    font-weight: 600;
    margin: 0 0 0.5rem;
  }

  .contacts-card-content {
    padding: 1rem 1.5rem;
  }

  .contacts-contract-row {
    margin-bottom: 1rem;
  }

  .contacts-contract-row > div {
    line-height: 1.6;
  }

  .contacts-authorities-section {
    min-width: 0;
  }

  .contacts-authorities-section .no-match-contacts {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 1rem;
  }

  .no-match-card-content .no-match-contacts {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 1rem;
  }

  .contacts-authorities-section a,
  .contacts-contract-row a {
    color: var(--isceco-color-blue-500);
    text-decoration: underline;
    word-break: break-word;
  }

  .employee-fields-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  .employee-field-item {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
  }

  .employee-field-item isceco-dropdown {
    width: 100%;
  }

  .salary-table {
    width: 100%;
    margin: 0.75rem 0 1rem;
  }

  .salary-table-title {
    margin: 0 0 0.5rem;
    font-weight: 600;
  }

  .salary-static-list {
    width: 100%;
  }

  .salary-table-placeholder {
    margin: 0.75rem 0 1rem;
    color: #666;
    font-style: italic;
  }

  .salary-no-basic {
    margin: 0.75rem 0 1rem;
    line-height: 1.5;
  }

  .salary-no-basic a {
    cursor: pointer;
    text-decoration: underline;
  }

  .details-hints-card {
    display: block;
    margin-top: 1rem;
  }

  .details-hints {
    padding: 1rem 1.5rem;
  }

  .details-hints-title {
    font-size: 1rem;
    font-weight: 600;
  }

  .details-hints-body {
    margin-top: 0.4rem;
  }

  .details-hints .accordion-item {
    margin-bottom: 0.15rem;
    padding-left: 0;
    padding-right: 0;
  }

  .details-hints .accordion-toggle {
    text-align: left;
    display: block;
    width: 100%;
    padding-left: 0;
    padding-right: 0;
    margin-left: 0;
    margin-right: 0;
  }

  .details-hints-body .accordion-toggle {
    font-size: 0.95rem;
  }

  .details-hints-body .accordion-content {
    font-size: 0.88rem;
    line-height: 1.55;
  }

  .details-hints .accordion-content {
    padding-bottom: 0.25rem;
  }

  .details-hints .accordion-content > :last-child {
    margin-bottom: 0;
  }

  .accordion-toggle.static {
    cursor: default;
  }

  @media (max-width: 768px) {
    .contacts-authorities-section .no-match-contacts {
      grid-template-columns: 1fr;
    }
  }
`
